import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=f59a3208&scoped=true&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"
import style0 from "./JobItem.vue?vue&type=style&index=0&id=f59a3208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a3208",
  null
  
)

export default component.exports